module.exports = __webpack_public_path__ + "static/media/yellow-lady-slipper.d1c99ada.jpg";